import React, { Fragment, useContext, useEffect, useState } from "react";
import WizardInput from "./WizardInput";
import { Col, CustomInput, Row } from "reactstrap";
import { Link } from "react-router-dom";
import { AuthWizardContext } from "../../../context/Context";
import { MARKETPLACE_ENABLED } from "../../../helpers/marketplaceEnabled";

const BasicUserForm = ({ register, errors, watch }) => {
  const { user, setUser } = useContext(AuthWizardContext);
  const [serverFieldError, setServerFieldError] = useState(null);

  // Si llegamos aquí por un correo duplicado al intentar registrarse, lo resaltamos
  useEffect(() => {
    const message = user._fieldErrors?.username;
    if (message) {
      setServerFieldError({ field: "username", message });
      setUser((prev) => {
        const { username, ...remaining } = prev._fieldErrors || {};
        const hasRemaining = Object.keys(remaining).length > 0;
        const { _fieldErrors, ...rest } = prev;
        return hasRemaining ? { ...rest, _fieldErrors: remaining } : rest;
      });
    }
  }, []); // eslint-disable-line

  const usernameErrors = serverFieldError && !errors.username
    ? { ...errors, username: { message: serverFieldError.message } }
    : errors;

  return (
    <>
      <WizardInput
        label="Correo electrónico*"
        placeholder="Correo electrónico"
        id="username"
        name="username"
        innerRef={register({
          required: "Correo electrónico es obligatorio",
          pattern: {
            value:
              /[A-Za-z0-9._%+-]{3,}@[a-zA-Z]{3,}([.]{1}[a-zA-Z]{2,}|[.]{1}[a-zA-Z]{2,}[.]{1}[a-zA-Z]{2,})/i,
            message: "Correo electrónico debe ser válido",
          },
        })}
        errors={usernameErrors}
      />
      <Row form>
        <Col>
          <WizardInput
            type="password"
            label="Contraseña*"
            placeholder="Contraseña"
            id="password"
            name="password"
            innerRef={register({
              required: "La contraseña es obligatoria",
              minLength: {
                value: 5,
                message: "La contraseña debe ser mas larga",
              },
            })}
            errors={errors}
          />
        </Col>
        <Col>
          <WizardInput
            type="password"
            label="Confirmar contraseña*"
            placeholder="Confirmar contraseña"
            id="password_confirmation"
            name="password_confirmation"
            innerRef={register({
              validate: (value) =>
                value === watch("password") || "Las contraseñas no coinciden",
            })}
            errors={errors}
          />
        </Col>
      </Row>
      <WizardInput
        type="checkbox"
        id="agreeToTerms"
        tag={CustomInput}
        label={
          <Fragment>
            Acepto los
            <a
              href="public/Terminos_de_uso_de_Homelan.docx"
              type="application/vnd.openxmlformats-officedocument.wordprocessingml.document"
              target="_blank"
              download
              onClick={(e) => {
                e.preventDefault();
                window.open("/terms", "_blank");
              }}
            >
               {' '}términos y condiciones
            </a>
          </Fragment>
        }
        name="agreeToTerms"
        innerRef={register({
          required:
            "Debe estar de acuerdo con nuestros términos y condiciones para continuar",
        })}
        errors={errors}
      />
      <div className="text-center mt-3">
        <p className="fs--1 text-600 mb-0">
          ¿Ya tienes una cuenta? <Link to="/authentication/login">Inicia sesión</Link>
        </p>
        {MARKETPLACE_ENABLED && (
          <p className="fs--1 text-600 mb-0 mt-1">
            ¿Ofreces servicios para el hogar? <Link to="/register/provider">Regístrate como proveedor</Link>
          </p>
        )}
      </div>
    </>
  );
};

export default BasicUserForm;
